import React from 'react';

type SortProps = {
  ascColor: string;
  descColor: string;
  className?: string;
};

const Sort = ({ ascColor, descColor, className = '' }: SortProps): JSX.Element => (
  <svg className={className} role="img" width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M0 4L4 0L8 4H0Z" fill={ascColor} />
    <path fillRule="evenodd" clipRule="evenodd" d="M0 8L4 12L8 8H0Z" fill={descColor} />
  </svg>
);

export default Sort;
